var map = {
	"./about-us.svg": 762,
	"./betting-icon.svg": 763,
	"./bonus.svg": 764,
	"./coin.png": 765,
	"./contact-us.svg": 766,
	"./download-app.svg": 767,
	"./edit-btn.svg": 768,
	"./feedback.svg": 769,
	"./global.svg": 770,
	"./info-centre.svg": 771,
	"./instant-rebate.svg": 772,
	"./mall-icon.svg": 773,
	"./message.svg": 774,
	"./redemption-icon.svg": 775,
	"./referral.svg": 776,
	"./resp-gaming.svg": 777,
	"./security.svg": 778,
	"./transaction-icon.svg": 779,
	"./vip-icon.svg": 780,
	"./wallet-icon.svg": 781
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 174;